import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// Import service
import { SpottradeService } from 'src/app/pages/spottrade/services/spottrade.service';

// Import models
import { PeriodicElement, QueryParams, Sorting } from "src/app/pages/spottrade/models/spottrade.model"
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

//import downloader
import { orderPDF, orderCSV, orderXLS, downloadFile } from './downloader';

// Import lib
import { encryptString } from 'src/app/lib/cryptoJs'

import * as moment from 'moment-timezone';

import isEmpty from 'src/app/lib/validte';
import { convert } from 'src/app/lib/roundOf';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-fake-local-order-filled',
  templateUrl: './fake-local-order-filled.component.html',
  styleUrls: ['./fake-local-order-filled.component.scss']
})
export class FackLocalOrderFilledComponent implements OnInit {
  statusOptions: string[] = ['all', 'open', 'pending', 'completed', 'cancel'];
  selectedStatus: string = 'all';

  convert = convert

  dataSource: MatTableDataSource<PeriodicElement> = new MatTableDataSource()
  //displayedColumns: string[] = ['createdAt', 'Country Code', 'Country Name', 'IP Address'];

  displayedColumns: string[] = ['Order No','Date', 'Reference Id', 'name' , 'Liquidity', 'User Id', 'Base Currency', 'Quote Currency', 'Type', 'Side', 'Execute price', 'Price', 'Filled Amount', 'Amount', 'Total', 'Status'];


  isLoading: boolean = false;

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];

  sorting: Sorting = {};

  export: string = 'pdf'
  queryParams = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize,
    type: ''
  };

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(
    private service: SpottradeService,
    private toastr: ToastrService,
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getData(): void {
    this.isLoading = true
    this.service.getLocalFilledDublicateOrderHistory(this.queryParams).subscribe({
      next: (v: any) => {
        const orderData = v.result.data;
        // this.dataSource = v.result.data
        const kycPromises = orderData.map((trade: any) => {

          if(trade.userId){
            this.userService.getSingleKyc(trade.userId).subscribe({
              next:(v:any)=>{
                // Add the salesUserPanNumber to the current trade object
                trade.name = v.result.userId.firstName +" " +v.result.userId.lastName;
              },
              error:(err)=>{
                console.log("the data is " , err);
                
              }
            })
          }
        } );
       
  
        Promise.all(kycPromises).then(() => {
          
          
          // All KYC requests have been resolved, update the dataSource
          this.dataSource = new MatTableDataSource(orderData);
          // Set pagination details
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = v.result.count;
          });
  
          this.isLoading = false;
        });

       
        // this.paginator.page = this.currentPage;
        // this.paginator.limit = v.result.count;
      },
      error: (err) => {
        this.isLoading = false

        const erros = err.error.errors
        if (!isEmpty(erros))
          this.toastr.error(erros.date)

        const filterObj = JSON.parse(this.queryParams.fillter || '{}');
        delete filterObj['sefd_orderDate'];
        this.queryParams.type = ''
        this.queryParams.fillter = JSON.stringify(filterObj);
      }
    });
  }


 handleDoc(value: any): void {
  const docType = {
    export: value,
    page: this.queryParams.page,
    limit: this.queryParams.limit,
    fillter: this.queryParams.fillter,
    sortObj: this.queryParams.sortObj,
  };

  this.service.getOrderHistoryDoc(docType).subscribe(
    (response: any) => {
      try {
        const parsed = JSON.parse(response); 
        const headers = parsed[0];          
        const rows = parsed.slice(1);        

        if (value === 'pdf') {
          const resultArr = rows.map((row: any[]) => {
            const convertedRow = [...row];
            const dateStr = convertedRow[1]; 
            convertedRow[1] = moment.tz(dateStr, 'MM-DD-YYYY HH:mm:ss', 'Asia/Kolkata')
                                   .format('YYYY-MM-DD hh:mm A');
            return convertedRow;
          });
          orderPDF(resultArr);
        }

       else if (value === 'xls') {
        const parsed = JSON.parse(response);
        const headers = parsed[0];
        const rows = parsed.slice(1);
        orderXLS(rows, headers);
      }

        else if (value === 'csv') {
          const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
          orderCSV(blob); 
        }

      } catch (err) {
        console.error('Export failed:', err);
      }
    },
    (err) => {
      console.error('API error:', err);
    }
  );
}




  onInputChange(event: Event, column: string) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.updateFilter(column, filterValue);
  }

  onOptionChange(event: any, column: string) {
    const filterValue = (event.source as HTMLSelectElement).value;
    this.updateFilter(column, filterValue);
  }

  onDateChange(event: any, column: string) {
    if (!event.value) {
      this.updateFilter(column, '');
      return
    }

    // const selectedDate: string = event.value.toISOString();
    const selectedDate: any = moment(event.value).format('YYYY-MM-DD');
    this.updateFilter(column, selectedDate);
  }

  pageChanged(event: PageEvent) {
    this.queryParams.page = event.pageIndex + 1;
    this.queryParams.limit = event.pageSize;
    this.getData()

    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  sortData(column: string) {
    if (this.sorting.column === column) {
      if (this.sorting.direction === 1) {
        this.sorting.direction = -this.sorting.direction;
      } else if (this.sorting.direction === -1) {
        this.sorting = {};
      }
    } else {
      this.sorting.column = column;
      this.sorting.direction = 1;
    }
    let sortObj = {};
    if (this.sorting.column) {
      sortObj = { [column]: this.sorting.direction };
    }
    this.queryParams.sortObj = JSON.stringify(sortObj)
    this.getData()
  }

  dateToDateSearch(event: any) {
    if (event.type == 'searchType') {
      this.queryParams.type = 'searchType'
      this.updateFilter(event.id, event.filterValue)
    } else if (event.type == 'clear') {
      this.queryParams.type = ''
      this.updateFilter(event.id, '')
    }
  }

  updateFilter(column: string, filterValue: string) {
    const filterKey =
      column === '_id' ? 'fid_id'
        : column === 'orderDate' ? 'fd_' + column
          : column === 'sefd_'
            ? column + 'orderDate'
            : column === 'execPrice' ||
              column === 'Price' ||
              column === 'filledQuantity' ||
              column === 'openQuantity' ||
              column === 'averagePrice'
              ? 'fn_' + column
              : 'fs_' + column;
    const filterObj = JSON.parse(this.queryParams.fillter || '{}');
    if (filterValue !== '') {
      filterObj[filterKey] = filterValue;
    } else {
      delete filterObj[filterKey];
    }
    this.currentPage = 0;
    this.queryParams.page = 1;
    this.queryParams.limit = this.pageSize;
    this.queryParams.fillter = JSON.stringify(filterObj);
    this.getData();
  }
  redirectToEdit(id: string) {
    this.router.navigateByUrl('/spottrade/pairedit/' + encryptString(id, true))
  }


  redirectToAdd() {
    this.router.navigateByUrl('/spottrade/pairadd')
  }



}






